import { ReactNode, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";
import { DesktopNav, MobileNav, UserProfileDropdown } from "@/components/navigation";

interface LayoutProps {
  children: ReactNode;
}

export function Layout({ children }: LayoutProps) {
  const { role } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Varmista että role on aina "admin" tai "installer"
  const userRole = role === "admin" ? "admin" : "installer";

  return (
    <div className="flex min-h-screen flex-col">
      {/* Header */}
      <header className="sticky top-0 z-50 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-16 items-center justify-between px-4">
          {/* Vasen puoli: Mobile menu + Logo + Desktop nav */}
          <div className="flex items-center gap-4">
            {/* Mobile menu trigger */}
            <MobileNav
              role={userRole}
              open={mobileMenuOpen}
              onOpenChange={setMobileMenuOpen}
            />

            {/* Logo */}
            <Link to="/" className="flex items-center gap-2">
              <div className="flex h-8 w-8 items-center justify-center rounded-md bg-primary text-primary-foreground font-bold text-sm">
                SF
              </div>
              <span className="hidden font-semibold sm:inline-block">
                StoneFlow Pro
              </span>
            </Link>

            {/* Desktop navigation */}
            <DesktopNav role={userRole} />
          </div>

          {/* Oikea puoli: User profile dropdown */}
          <UserProfileDropdown />
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1 container py-6 px-4">{children}</main>
    </div>
  );
}
